import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
import { CmsContainer } from './CmsContainer';
interface CmsGridProps {
  columns?: 2 | 3 | 4;
  children: React.ReactNode;
  className?: string;
}
export function CmsGrid(t0) {
  const $ = _c(10);
  const {
    columns: t1,
    children,
    className
  } = t0;
  const columns = t1 === undefined ? 3 : t1;
  const t2 = columns === 2 && "md:grid-cols-2";
  const t3 = columns === 3 && "md:grid-cols-2 lg:grid-cols-3";
  const t4 = columns === 4 && "md:grid-cols-2 lg:grid-cols-4";
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = cn("grid gap-6 md:gap-8", "grid-cols-1", t2, t3, t4);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== children || $[5] !== t5) {
    t6 = <div className={t5}>{children}</div>;
    $[4] = children;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== className || $[8] !== t6) {
    t7 = <CmsContainer className={className}>{t6}</CmsContainer>;
    $[7] = className;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}